import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = ({ cssProps }) => ({
  pointerEvents: cssProps.loading ? 'none' : 'auto',
  flexDirection: 'column',
  padding: '16px',
  gap: '16px',
  width: '100%',
});

export const inputField: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'row',
});

export const checkboxButton: CSSFunction = () => ({
  padding: '0',
  borderRadius: '0',
  fontSize: '18px',
  height: '18px',
  width: '18px',
});

export const textArea: CSSFunction = ({ theme }) => ({
  width: '100% !important',
  fontSize: theme.fontSizes.body,
  padding: '4px',
});

export const rupeeIcon: CSSFunction = ({ theme }) => ({
  color: color(theme, 'text.1'),
  width: '12px',
  height: '12px',
});

export const lengthValidation: CSSFunction = ({ theme }) => ({
  color: color(theme, 'text.2'),
  marginLeft: 'auto',
  fontSize: '12px',
});
